import React, { useState } from "react";
import { qformat, DATE_FORMATS } from "views_shared/app/javascript/utils/dateFormatters";
import CompanyJobResult from "./CompanyJobResult";
import MediaItemResult from "./MediaItemResult";
import MediaJobResult from "./MediaJobResult";
import MediaOutletResult from "./MediaOutletResult";
import MediaProfileResult from "./MediaProfileResult";
import PitchResult from "./PitchResult";
import PromoCompanyResult from "./PromoCompanyResult";
import PromoExpertResult from "./PromoExpertResult";
import PromoProductResult from "./PromoProductResult";
import PromoterProfileResult from "./PromoterProfileResult";
import PublicPitchResult from "./PublicPitchResult";
import QuoteResult from "./QuoteResult";
import RequestResult from "./RequestResult";

// Function to determine and render the correct result component
const renderResultComponent = (result, setResultTitle, setResultUrl, setHidden) => {
  const gid = result.model_gid;
  const match = gid.match(/gid:\/\/qwoted\/([^/]+)\/\d+/);
  const type = match ? match[1] : null;

  switch (type) {
    case "Id::CompanyJob":
      return (
        <CompanyJobResult gid={gid} setResultTitle={setResultTitle} setResultUrl={setResultUrl} setHidden={setHidden} />
      );
    case "Id::MediaItem":
      return (
        <MediaItemResult gid={gid} setResultTitle={setResultTitle} setResultUrl={setResultUrl} setHidden={setHidden} />
      );
    case "Id::MediaJob":
      return (
        <MediaJobResult gid={gid} setResultTitle={setResultTitle} setResultUrl={setResultUrl} setHidden={setHidden} />
      );
    case "Id::MediaOutlet":
      return (
        <MediaOutletResult
          gid={gid}
          setResultTitle={setResultTitle}
          setResultUrl={setResultUrl}
          setHidden={setHidden}
        />
      );
    case "Id::Profile::MediaProfile":
      return (
        <MediaProfileResult
          gid={gid}
          setResultTitle={setResultTitle}
          setResultUrl={setResultUrl}
          setHidden={setHidden}
        />
      );
    case "Id::Profile::Promoter":
      return (
        <PromoterProfileResult
          gid={gid}
          setResultTitle={setResultTitle}
          setResultUrl={setResultUrl}
          setHidden={setHidden}
        />
      );
    case "Id::PromoEntity::Company":
      return (
        <PromoCompanyResult
          gid={gid}
          setResultTitle={setResultTitle}
          setResultUrl={setResultUrl}
          setHidden={setHidden}
        />
      );
    case "Id::PromoEntity::Expert":
      return <PromoExpertResult gid={gid} setHidden={setHidden} />;
    case "Id::PromoEntity::Product":
      return (
        <PromoProductResult
          gid={gid}
          setResultTitle={setResultTitle}
          setResultUrl={setResultUrl}
          setHidden={setHidden}
        />
      );
    case "Id::Quote":
      return (
        <QuoteResult gid={gid} setResultTitle={setResultTitle} setResultUrl={setResultUrl} setHidden={setHidden} />
      );
    case "Interact::Pitch":
      return (
        <PitchResult gid={gid} setResultTitle={setResultTitle} setResultUrl={setResultUrl} setHidden={setHidden} />
      );
    case "Interact::Request":
      return (
        <RequestResult gid={gid} setResultTitle={setResultTitle} setResultUrl={setResultUrl} setHidden={setHidden} />
      );
    case "Enrich::PublicPitch":
      return (
        <PublicPitchResult
          gid={gid}
          setResultTitle={setResultTitle}
          setResultUrl={setResultUrl}
          setHidden={setHidden}
        />
      );
    default:
      return null;
  }
};

function ResultWrapper({ result }) {
  const [hidden, setHidden] = useState(false);
  const [resultTitle, setResultTitle] = useState(null);
  const [resultUrl, setResultUrl] = useState(null);
  const [showFullText, setShowFullText] = useState(false);
  const [showFullDetails, setShowFullDetails] = useState(false);

  if (!result.model_text) {
    return null;
  }

  const toggleTextDisplay = () => setShowFullText(!showFullText);
  const toggleDetailsDisplay = () => setShowFullDetails(!showFullDetails);

  const modelTextParts = result.model_text.split("__DELIM__");
  const displayText = modelTextParts.join(" ... ");

  const textSnippet = displayText.length > 400 && !showFullText ? `${displayText.substring(0, 397)}...` : displayText;

  const detailsSnippet = showFullDetails ? ` | ${result.model_gid} | ${result.embedding_type}` : "...";

  const formattedDate = qformat(result.model_updated_at, DATE_FORMATS.date);

  return (
    <div className={`mb-4 ${hidden ? "d-none" : ""}`} key={result.model_gid}>
      {renderResultComponent(result, setResultTitle, setResultUrl, setHidden)}
      <a href={resultUrl} className="text-primary fs-3 mb-1">
        {resultTitle}
      </a>
      <div
        className="result-text mb-2"
        style={{ cursor: "pointer" }}
        onClick={toggleTextDisplay}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            toggleTextDisplay();
          }
        }}
      >
        {textSnippet}
      </div>
      <div
        className="text-muted small mb-2"
        style={{ cursor: "pointer" }}
        onClick={toggleDetailsDisplay}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            toggleDetailsDisplay();
          }
        }}
      >
        Distance: <strong>{result.distance.toFixed(2)}</strong> | {formattedDate}
        {detailsSnippet}
      </div>
    </div>
  );
}

export default ResultWrapper;
